var render, staticRenderFns
import script from "./VerticalBarChart.vue?vue&type=script&lang=js&"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa8858",
  null
  
)

export default component.exports